import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { Typography } from "@mui/material";
//
//
const SelectBox = ({ className, label, id, ItemsMenu, error, ...props }) => {
  const styles = {
    Typography: {
      fontFamily: "Roboto",
      fontSize: "16px",
      fontWeight: "500",
      lineHeight: "20px",
      color: "#767676",
    },
  };

  return (
    <>
      <div className={`InputControl ${className}`} key={id}>
        <label htmlFor={id}>{label}</label>
        <FormControl variant="standard">
          <Select style={styles.Typography} error={error}>
            <MenuItem value="" style={styles.Typography}>
              <em>None</em>
            </MenuItem>
            {ItemsMenu?.map((data, index) => {
              return (
                <MenuItem
                  value={data.entity}
                  key={index}
                  style={styles.Typography}
                >
                  {data.entity}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
      </div>
    </>
  );
};
//
//
export default SelectBox;
